import { COLORS } from "./constants";

export const panelSx = {
  p: { xs: 2, md: 3 }, bgcolor: COLORS.panel, border: `1px solid ${COLORS.border}`,
  borderRadius: "20px"
};

// For a panel rendered INSIDE another panel (the Source card holds the preview
// and the selected source's settings): no second border, fill or padding.
export const barePanelSx = { p: 0, bgcolor: "transparent", border: "none", borderRadius: 0 };

export const sectionTitleSx  = { color: COLORS.text, fontFamily: COLORS.fontDisplay, fontWeight: 700, fontSize: 18, lineHeight: 1.25 };
export const sectionSubtleSx = { mt: 0.35, color: COLORS.muted, fontSize: 13 };

export const primaryButtonSx = {
  borderRadius: "11px", textTransform: "none", fontWeight: 600, fontFamily: COLORS.fontSans,
  bgcolor: COLORS.accent, color: COLORS.onAccent, boxShadow: "none",
  "&:hover": { bgcolor: COLORS.cyan, boxShadow: "none" }
};

export const secondaryButtonSx = {
  alignSelf: "flex-start", borderRadius: "11px", textTransform: "none", fontWeight: 600,
  color: COLORS.cyan, borderColor: "rgba(43,189,175,0.42)",
  "&:hover": { bgcolor: "rgba(43,189,175,0.10)", borderColor: COLORS.cyan }
};

export const ghostButtonSx = {
  borderRadius: "11px", textTransform: "none", fontWeight: 600, px: 2,
  color: COLORS.text, border: `1px solid ${COLORS.borderStrong}`,
  "&:hover": { bgcolor: "rgba(255,255,255,0.05)" }
};

// White on dangerFill clears 4.5:1; the lighter `red` is for text and icons only.
export const dangerButtonSx = {
  borderRadius: "11px", textTransform: "none", fontWeight: 600, px: 2,
  bgcolor: COLORS.dangerFill, color: "#fff", boxShadow: "none",
  "&:hover": { bgcolor: "#BC3237", boxShadow: "none" }
};

export const statusPillSx = {
  borderRadius: "999px", bgcolor: COLORS.panelSoft, color: COLORS.text,
  border: `1px solid ${COLORS.border}`, fontWeight: 600
};

export const previewButtonSx = (color) => ({
  color, border: `1px solid ${COLORS.border}`, borderRadius: "10px",
  bgcolor: "rgba(255,255,255,0.035)",
  "&:hover": { bgcolor: "rgba(255,255,255,0.075)", borderColor: color }
});

export const inputSx = {
  "& .MuiOutlinedInput-root": {
    bgcolor: COLORS.input, borderRadius: "11px", color: COLORS.text,
    fontFamily: COLORS.fontMono, fontSize: "0.82rem",
    "& fieldset": { borderColor: COLORS.border },
    "&:hover fieldset": { borderColor: COLORS.borderStrong },
    "&.Mui-focused fieldset": { borderColor: COLORS.cyan },
    "&.Mui-focused": { boxShadow: "0 0 0 3px rgba(43,189,175,0.15)" }
  },
  "& .MuiInputBase-input::placeholder": { color: COLORS.muted, opacity: 0.86 }
};

// Prose fields (stream title, description, labels) use the body font; only
// machine values (URLs, keys) are monospace.
export const proseInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": { ...inputSx["& .MuiOutlinedInput-root"], fontFamily: COLORS.fontSans, fontSize: "0.9rem" }
};

export const commonInputProps = { size: "small", variant: "outlined", fullWidth: true, sx: inputSx };
